module["exports"] = [
  "#{prefix} #{Name.last_name}"
];
